<template>
  <div class="resource">
    <div class="clearfix">
      <div class="fl collect">
        <div class="clearfix top">
          <span class="title fl"> 我的备课 </span>
          <span
            class="fr"
            @click="$router.push('/prepareLessons')"
            style="cursor: pointer"
            >更多 ></span
          >
        </div>

        <div
          v-for="(item, index) in list"
          :key="index"
          class="list"
          @click="$router.push('/prepareLessons')"
        >
          <img align="absmiddle" src="../../assets/beike (2).png" alt="" />
          <span class="text">{{ item.lesson_name }} </span>
          <span class="fr time">{{
            new Date(parseInt(item.create_time) * 1000)
              .toLocaleString()
              .replace(/:\d{1,2}$/, " ")
          }}</span>
        </div>
        <div v-show="list.length == 0" align="center" style="padding-top: 90px">
          <img src="@/assets/zanwu.png" alt="" style="width: 80px" />
        </div>
      </div>

      <div class="fr push">
        <div class="clearfix top">
          <span class="title fl" style="text-align: right"> 资源推荐 </span>
          <span
            class="fr"
            @click="$router.push('/resourceCenter')"
            style="cursor: pointer"
            >更多 ></span
          >
        </div>

        <div
          v-for="(item, index) in listdata"
          :key="index"
          class="list clearfix"
          @click="item_xiangqing(item, index)"
        >
          <svg
            class="ziyuan_icon fl"
            aria-hidden="true"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'doc'"
          >
            <use xlink:href="#iconword"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            aria-hidden="true"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'ppt'"
          >
            <use xlink:href="#iconppt"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            aria-hidden="true"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'ptx'"
          >
            <use xlink:href="#iconppt"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            aria-hidden="true"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'ocx'"
          >
            <use xlink:href="#iconword"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            aria-hidden="true"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'lsx'"
          >
            <use xlink:href="#iconexcel"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'png'"
            aria-hidden="true"
          >
            <use xlink:href="#icontupian1"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'jpg'"
            aria-hidden="true"
          >
            <use xlink:href="#icontupian1"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'mp4'"
            aria-hidden="true"
          >
            <use xlink:href="#iconshipin1"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'exe'"
            aria-hidden="true"
          >
            <use xlink:href="#iconweizhiwenjian"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'mp3'"
            aria-hidden="true"
          >
            <use xlink:href="#iconweizhiwenjian"></use>
          </svg>
          <svg
            class="ziyuan_icon fl"
            v-if="item.file_name.substring(item.file_name.length - 3) == 'wmv'"
            aria-hidden="true"
          >
            <use xlink:href="#iconweizhiwenjian"></use>
          </svg>
          <div class="ziyuan_title fl">{{ item.file_name }}</div>
          <div class="ziyuan_time fr">{{ item.upload_time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/index";
export default {
  data() {
    return {
      list: [],
      listdata: [],
    };
  },
  components: {},
  mounted() {
    this.handlelist();
    this.handlelist1();
  },
  methods: {
    // 备课列表
    handlelist() {
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        range: "my",
        page: 1,
        num: 6,
        keyword: 0,
        grade_id: 0,
        subject_id: 0,
        start_time: 0,
        end_time: 0,
      };
      this.$post(URL.getLessonList, data).then((res) => {
        // console.log(res.result.list[0].content,'beike')
        // console.log(res.result.list[0].content[1],'beike')
        this.list = res.result.list.slice(0, 5);
      });
    },
    // 资源列表
    handlelist1() {
      var data = {
        subject: 1,
      };
      this.$post(URL.recommendfiles2, data).then((res) => {
        // console.log(res.result.new)
        this.listdata = res.result.new.slice(0, 5);
      });
    },
    item_xiangqing(item, index) {
      var data = {
        fileid: this.listdata[index].file_id,
      };

      this.$get(URL.fileView, data).then((res) => {});
      this.$router.push({
        name: "details",
        query: {
          data: this.listdata[index],
        },
      });
      localStorage.setItem("item_xiangqing", JSON.stringify(this.listdata[index]));
    },
  },
};
</script>

<style lang='less' scoped>
.resource {
  width: 770px;
  background-color: #fff;
  margin-top: 15px;
  border-radius: 8px;
  padding: 10px 30px;
  .title {
    font-size: 18px;
    border-left: 4px solid #409eff;
    padding-left: 20px;
  }
  .collect {
    width: 46%;
    margin-right: 30px;
  }
  .push {
    width: 46%;
  }
  .top {
    border-bottom: 1px solid #f4f4f4;
    padding-bottom: 6px;
    margin-bottom: 8px;
  }
  .list {
    img {
      width: 15px;
      height: 15px;
    }
    height: 50px;
    line-height: 50px;
    // cursor: pointer;
    font-size: 14px;
    span {
      display: inline-block;
      vertical-align: middle;
    }
    .ziyuan_icon {
      width: 48px;
      height: 48px;
    }
    .ziyuan_title {
      width: 170px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .ziyuan_time {
      line-height: 48px;
      font-family: MicrosoftYaHei;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #b0b0b0;
    }
  }
  .list:hover {
    color: #409eff;
    cursor: pointer;
  }
  .time {
    font-size: 14px;
    color: rgb(153, 151, 151);
  }
  .text {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
